<button type="button"
        class="schedule-lot-card"
        [attr.aria-label]="'View lot summary for ' + primaryText() + ', ' + secondaryText()"
        (click)="cardClick.emit(card())"
        data-testid="cm-card-schedule-lot">
  <div class="schedule-lot-card-main">
    <span class="schedule-lot-card-lot"
          data-testid="cm-text-lot-block">{{ primaryText() }}</span>
    <span class="schedule-lot-card-detail"
          data-testid="cm-text-lot-detail">{{ secondaryText() }}</span>
  </div>

  <i class="pi pi-chevron-right schedule-lot-card-chevron"
     aria-hidden="true"></i>

  <div class="schedule-lot-card-footer">
    <span class="schedule-lot-card-step">
      @for (step of card().steps; track step.id; let isLast = $last) {
        <span class="schedule-lot-card-step-item">
          @if (syncBadgeFor(step); as badge) {
            <p-tag [severity]="badge.severity"
                   class="schedule-lot-card-sync-tag"
                   [rounded]="true"
                   (click)="onSyncStatusClick($event, step)"
                   [attr.aria-label]="badge.label"
                   [attr.title]="badge.label"
                   [attr.data-testid]="badge.testId">
              <i [class]="badge.icon"></i>
            </p-tag>
          }
          <span data-testid="cm-text-step-label">{{ step.getStepLabel() }}{{ isLast ? dateSuffix() : "," }}</span>
        </span>
      }
    </span>

    @if (card().isOverdue) {
      <p-tag severity="danger"
             class="schedule-lot-card-overdue-tag"
             [rounded]="true"
             value="Overdue"
             data-testid="cm-job-schedule-badge-overdue" />
    }
  </div>
</button>
